import { JsonConverter, JsonCustomConvert } from 'json2typescript';

import { MifidCategoryCode } from '../../../../../core';

@JsonConverter
export class MifidCategoryCodeAdapter implements JsonCustomConvert<MifidCategoryCode | undefined> {
    serialize(type: MifidCategoryCode): any | undefined {
        return type ? String(type) : undefined;
    }

    deserialize(type: any): MifidCategoryCode | undefined {
        switch (type) {
            case 'MI':
                return MifidCategoryCode.MI;
            case 'CR':
                return MifidCategoryCode.CR;
            case 'PR':
                return MifidCategoryCode.PR;
            default:
                return undefined;
        }
    }
}
